import PropTypes from 'prop-types'
import SkillProviders from '../components/SkillProviders'

const CareerSkills = ({ studentUserId, studentName, childSelector }) => {
    return (
        <SkillProviders
            studentUserId={studentUserId}
            studentName={studentName}
            childSelector={childSelector}
        />
    )
}

CareerSkills.propTypes = {
    studentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studentName: PropTypes.string,
    childSelector: PropTypes.node,
}

export default CareerSkills
